import React, { useEffect } from 'react';
import { Box } from '@mui/material';

import { EControlPositionType, IEnrichedUniswapPosition } from '../../types/uniswapTokens';
import { LeveragePositionInfo } from './LeveragePositionInfo';
import { LeveragePositionRange } from './LeveragePositionRange';

export interface IPositionDetailsProps extends IEnrichedUniswapPosition {
  notLeveraged?: boolean;
  columnsType: 'lending' | 'leverage' | 'leveraged';
}

export const PositionDetails = (props: IPositionDetailsProps) => {
  useEffect(() => {
    if (props.columnsType === 'lending') {
      window.gtag('event', 'lending_position_unfold');
    }
    if (props.columnsType === 'leverage') {
      window.gtag('event', 'leverage_position_unfold');
    }
    if (props.columnsType === 'leveraged') {
      window.gtag('event', 'leveraged_position_unfold');
    }
  }, []);

  return (
    <Box sx={{
      display: 'flex',
      flexDirection: 'column',
      gap: 4,
      p: 6,
      width: 'calc(100% + 48px)',
      backgroundColor: '#1F1F23',
    }}>
      <LeveragePositionInfo {...props} />
      {props.controlType === EControlPositionType.ManualPosition && (
        <LeveragePositionRange {...props} />
      )}
    </Box>
  );
};
